<template>
    <div class="playlist-container">
        <div class="main-content">
            <el-card class="playlist-title-card">
                <h1 class="playlist-title">教程大全</h1>
                <p class="playlist-description">
                    收录各类操作教程，包括但不限于：积分兑换操作、周边登记流程、小程序使用指南、二创规范实操。
                </p>
            </el-card>
        </div>

        <!-- 搜索框，快速跳转 -->
        <div style="display: flex;padding: 20px;">
            <el-row :gutter="20" style="width: 100%;">
                <el-col :span="24" style="display: flex; align-items: center;">
                    <span style="flex-shrink: 0; margin-right: 10px;padding-left: 20px;font-weight: bold;">快速搜索：</span>
                    <el-input v-model="input" placeholder="请输入教程关键词"
                        style="flex: 1; box-sizing: border-box;padding-right: 10px;" clearable></el-input>
                    <el-button type="primary">搜索</el-button>
                </el-col>
            </el-row>
        </div>

        <!-- 核心教程内容（标签页布局） -->
        <div class="rulesCard">
            <el-card>
                <h2 class="rulesTitle">📋 直播间推荐</h2>
                <p class="rulesDescription">
                    推荐直播间将有助于推流。
                </p>
                <div class="rulesContent" style="padding: 10px 20px; line-height: 2;">
                    <div style="margin-bottom: 15px;">
                        <div style="height: 50px;
                        width: 40px;">
                            图片占位
                        </div>
                        <span style="font-weight: bold; color: #333;">1. 直播间推荐：</span>
                        <ul style="margin: 5px 0 0 20px; padding: 0; color: #666;"></ul>
                    </div>
                </div>
            </el-card>
        </div>

        <!-- 进阶教程（效仿原页面的独立卡片布局） -->
        <div class="rulesCard">
            <el-card>
                <h2 class="rulesTitle">💡 进阶教程</h2>
                <p class="rulesDescription">
                    针对复杂操作的详细教程，帮助你解决各类特殊场景问题。
                </p>
                <div class="rulesContent" style="padding: 10px 20px; line-height: 2;">
                    <div style="margin-bottom: 15px;">
                        <span style="font-weight: bold; color: #333;">1. 小程序使用教程：</span>
                        <ul style="margin: 5px 0 0 20px; padding: 0; color: #666;">
                            <li>扫码进入点歌小程序后，先绑定抖音ID（仅需首次绑定）。</li>
                            <li>选择歌单类型→填写点歌信息→提交订单→扣除积分完成点歌。</li>
                            <li>小程序订单可在「我的订单」中查看进度，支持取消未开始的订单。</li>
                        </ul>
                    </div>
                    <div style="margin-bottom: 15px;">
                        <span style="font-weight: bold; color: #333;">2. 二创规范实操：</span>
                        <ul style="margin: 5px 0 0 20px; padding: 0; color: #666;">
                            <li>创作前确认素材使用权限，官方皮套禁止用于制品制作。</li>
                            <li>饭制皮套二创需先联系原作者获取授权，保留授权记录备查。</li>
                            <li>发布二创内容时需标注来源，禁止盗用他人作品。</li>
                        </ul>
                    </div>
                </div>
            </el-card>
        </div>

        <!-- 常见问题（效仿原页面的独立卡片布局） -->
        <div class="rulesCard">
            <el-card>
                <h2 class="rulesTitle">❓ 常见问题解答</h2>
                <p class="rulesDescription">
                    教程相关的高频问题，快速解决你的操作疑惑。
                </p>
                <div class="rulesContent" style="padding: 10px 20px; line-height: 2;">
                    <el-collapse>
                        <el-collapse-item title="积分兑换后多久到账？">
                            <div style="font-size: 14px; color: #666;">
                                审核通过后1-3个工作日内录入，可联系管理查询积分到账状态。
                            </div>
                        </el-collapse-item>
                        <el-collapse-item title="登记信息填错了怎么办？">
                            <div style="font-size: 14px; color: #666;">
                                未审核的信息可联系管理修改，审核通过后无法修改，需重新登记（仅开放一次补登机会）。
                            </div>
                        </el-collapse-item>
                        <el-collapse-item title="小程序点歌提示积分不足？">
                            <div style="font-size: 14px; color: #666;">
                                请先确认积分已录入账户，若仍提示不足可核对歌单积分消耗标准，或联系管理复核积分数量。
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // 搜索框绑定值
            input: '',
            // 标签页激活项
            activeName: 'first',
            // 折叠控制（操作截图）
            isScreenshotCollapse: true,
            // 登记链接（可替换为实际链接）
            registerLinks: {
                annualSeason: 'https://www.wjx.top/vm/h4LoeGR.aspx',
                continuous: 'https://www.wjx.top/vm/PvfYDbS.aspx'
            }
        }
    },
    methods: {
        // 折叠/展开操作截图
        toggleScreenshot() {
            this.isScreenshotCollapse = !this.isScreenshotCollapse;
        },
        // 打开登记链接
        openLink(type) {
            window.open(this.registerLinks[type], '_blank');
        }
    }
}
</script>

<style scoped>
/* 复用原有页面的所有样式，保证视觉统一 */
.main-content {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
}

.playlist-title-card {
    text-align: center;
    margin-bottom: 30px;
    border-radius: 10px;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    border: none;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.playlist-title {
    font-size: 28px;
    color: #ffad32;
    margin-bottom: 10px;
    letter-spacing: 2px;
    font-weight: bold;
}

.playlist-description {
    font-size: 16px;
    color: #666;
    line-height: 1.6;
}

.rulesCard {
    padding: 20px;
    margin-bottom: 20px;
}

.rulesDescription {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    margin-bottom: 20px;
}

.rulesContent {
    padding: 0 0 20px 0;
}

.rulesTitle {
    font-size: 25px;
    color: #ffad32;
    margin-bottom: 10px;
    font-weight: bold;
}

/* 折叠控制样式（复用） */
.collapse-control {
    border-bottom: 1px dashed #e6e6e6;
    padding-bottom: 10px;
}

.collapse-control .el-button {
    font-size: 14px;
    color: #333;
    padding: 0;
}

.collapse-control .el-button:hover {
    color: #409eff;
}

/* 提醒样式（复用） */
.reminder {
    margin-top: 20px;
    padding: 20px;
    background: #fff3cd;
    border-radius: 8px;
    color: #856404;
    line-height: 1.8;
}

/* 特别说明样式（复用） */
.special-notice {
    background-color: #e6fffa !important;
    border: 1px solid #99f6e4 !important;
}

/* 二维码/截图占位样式（复用） */
.qrcode-placeholder {
    width: 200px;
    height: 200px;
    background: #f5f5f5;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    margin: 0 auto;
}
</style>